if (!customElements.get('gb-shimano-guide')) {
  customElements.define('gb-shimano-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const search = this.querySelector('[data-guide-search]');
      const input = this.querySelector('input[type="search"]');
      const cards = [...this.querySelectorAll('[data-pad-family]')];
      const status = this.querySelector('[data-guide-status]');
      const empty = this.querySelector('[data-guide-empty]');
      if (!search || !input || !cards.length) return;
      const normalise = value => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]/g, '');
      const normaliseCode = value => normalise(value).replace(/^br/, '').replace(/(rx|mx|rf|mf)$/, '');
      const entries = cards.map(card => ({card, codes: card.dataset.models.split(/[·/]/).map(normaliseCode), heading: normalise(card.querySelector('h3').textContent)}));
      const update = () => {
        const value = normaliseCode(input.value);
        const hasExact = value && entries.some(entry => entry.codes.includes(value));
        let count = 0;
        entries.forEach(({card, codes, heading}) => {
          const matches = !value || (hasExact ? codes.includes(value) : codes.some(code => code.includes(value)) || heading.includes(value));
          card.hidden = !matches;
          if (matches) count++;
          if (value && matches) card.querySelector('details').open = true;
          if (!value) card.querySelector('details').open = false;
        });
        status.textContent = `${status.dataset.label} ${count} / ${cards.length}`;
        empty.hidden = count > 0;
      };
      input.addEventListener('input', update);
      this.querySelector('[data-guide-reset]').addEventListener('click', () => {input.value = ''; update(); input.focus();});
      this.querySelectorAll('[data-family-jump]').forEach(link => link.addEventListener('click', () => {
        if (input.value) {input.value = ''; update();}
      }));
      search.hidden = false;
      update();
    }
  });
}
